import { IActivityFeedUserData } from './activity-feed-user.interface';

export interface IActivityFeedPostData {
  image?: string;
  text: string;
  edited_at?: string;
}

export interface IActivityFeedPostActor {
  id: string;
  created_at: string;
  updated_at: string;
  data: IActivityFeedUserData;
}

export interface IActivityFeedPostOptions {
  edit: boolean;
  delete: boolean;
}

export interface IActivityFeedPost {
  verb: string;
  time: string;
  target: string;
  origin: string;
  object: string;
  id: string;
  foreign_id: string;
  post: IActivityFeedPostData;
  actor: IActivityFeedPostActor;

  // Virtual property calculated in the service based on user permissions
  options?: IActivityFeedPostOptions;
}
